<template>
  <div class="overview">
    <div class="alert alert-info">
      Welcome back, {{ $user.userData.fullName }}!
    </div>
    <div v-if="$user.administrator">
      <div class="row">
        <div class="col">
          <div class="alert alert-success" role="alert">
            Total Invoiced Today: {{ invoicedToday }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-9">
          <div class="row">
            <div class="col-lg-4" v-for="(report, index) in reports" :key="index">
              <div class="card">
                <router-link :to="report.path">
                  <div class="content">
                    <div class="row">
                      <div class="col-4">
                        <img
                          :src="'https://s3-ap-southeast-2.amazonaws.com/roscon/' + report.iconKey"
                          :alt="report.reportType"
                          class="img-thumbnail float-left count-icon">
                      </div>
                      <div class="col-8 text-right">
                        <h5>{{ report.name }}</h5>
                        <div class="numbers">
                          <i-count-up :start="0" :end="report.max" :decimals="0" :duration="3" :options="options"></i-count-up>
                        </div>
                      </div>
                    </div>
                    <div class="footer small">
                      <hr>
                      <div class="stats" v-if="timePassed == 0">
                        <i class="fa fa-sync"></i> Updated now
                      </div>
                      <div class="stats" v-else>
                        <i class="far fa-clock"></i> Updated {{ timePassed }} min ago
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div v-if="index === 0" class="show-on-mobile card">
                <router-link :to="'/quotes'">
                  <div class="content">
                    <div class="row">
                      <div class="col-4">
                        <img
                          :src="'https://s3-ap-southeast-2.amazonaws.com/roscon/data/6375fe7b0574872de52263b65d7844ad.jpg'"
                          :alt="'Quotes'"
                          class="img-thumbnail float-left count-icon">
                      </div>
                      <div class="col-8 text-right">
                        <h5>Quotes</h5>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div v-if="index === 0" class="show-on-mobile card">
                <router-link :to="'/database-search'">
                  <div class="content">
                    <div class="row">
                      <div class="col-4">
                        <img
                          :src="'https://s3-ap-southeast-2.amazonaws.com/roscon/data/deb15929393be0a70b7e788a055d6934.jpg'"
                          :alt="'DBS'"
                          class="img-thumbnail float-left count-icon">
                      </div>
                      <div class="col-8 text-right">
                        <h5>Database Search</h5>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <h2>
            This week
          </h2>
          <div class="row">
            <div class="col-lg-6">
              <div class="card">
                <div class="content">
                  <chart
                    :labels="reportTypeData.labels"
                    :datasets="reportTypeData.datasets"
                    ref="reportTypeData" :type="'pie'">
                  </chart>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="card">
                <div class="content">
                  <chart 
                    :currency="true"
                    :labels="incomeData.labels"
                    :datasets="incomeData.datasets"
                    ref="incomeData" :type="'line'"
                    :scales="incomeChartScale">
                  </chart>
                </div>
              </div>
            </div>
          </div>
          <!-- <object-select-input :options="{objects: dashboard.accountCodes, objectName: 'dropdownLabel', value: null, label: 'Invoice Type'}"></object-select-input> -->
          <h3>
            Quotes
          </h3>
          <stats-over-time-periods :data="dashboard.quotes"/>
          <h3>
            Accepted Quotes
          </h3>
          <stats-over-time-periods :data="dashboard.acceptedQuotes"/>
          <h3>
            Tax Invoices
          </h3>
          <stats-over-time-periods :data="dashboard.invoices"/>
          <h3>
            Active Work Orders
          </h3>
          <responsive-table
            :hideTitle="true"
            :table="{ columns: dashboard.workOrderData ? dashboard.workOrderData.header : '' }">
            <template slot="rows">
              <template v-for="(row, i) in dashboard.workOrderData ? dashboard.workOrderData.rows : []">
                <component
                  :is="'work-order-summary-row'"
                  :object="row"
                  :index="i"
                  :key="i">
                </component>
              </template>
            </template>
          </responsive-table>
        </div>
        <div class="col-12 col-lg-3">
          <h3>
            <i class="fa fa-history"></i> Recent Activity
            <router-link :to="'live-feed'" class="btn btn-secondary btn-sm pull-right my-2">View All Activity</router-link>
          </h3>
          <feed-item v-for="item in liveFeed" :object="item" :key="item.uuid"></feed-item>
        </div>
      </div>
    </div>
    <div v-if="$user.manager">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-lg-4" v-for="(clientDashItem, index) in clientDashboard" :key="index">
              <div class="card">
                <router-link :to="clientDashItem.path">
                  <div class="content">
                    <div class="row">
                      <div class="col-4">
                        <img
                          :src="'https://s3-ap-southeast-2.amazonaws.com/roscon/' + clientDashItem.iconKey"
                          :alt="clientDashItem.name"
                          class="img-thumbnail float-left count-icon">
                      </div>
                      <div class="col-8 text-right">
                        <h5>{{ clientDashItem.name }}</h5>
                        <div class="numbers animated bounce">
                          {{ clientDashItem.max }}
                        </div>
                      </div>
                    </div>
                    <div class="footer small">
                      <hr>
                      <div class="stats" v-if="timePassed == 0">
                        <i class="fa fa-sync"></i> Updated now
                      </div>
                      <div class="stats" v-else>
                        <i class="far fa-clock"></i> Updated {{ timePassed }} min ago
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .card a {
    color: #000;
    &:hover {
      text-decoration: none;
    }
  }
</style>

<script>
  import { LOAD_DASHBOARD } from '@/vuex/types'
  import { mapGetters } from 'vuex'
  import FeedItem from '@/components/cards/FeedItemSmall'
  import Chart from '@/components/displays/Chart'
  import StatsOverTimePeriods from '@/components/displays/StatsOverTimePeriods'
  import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'
  import ICountUp from 'vue-countup-v2'
  import ResponsiveTable from '@/components/ui/ResponsiveTable.vue'
  import WorkOrderSummaryRow from '@/components/rows/WorkOrderSummary.vue'
  export default {
    name: 'Overview',
    components: {
      ICountUp,
      FeedItem,
      Chart,
      StatsOverTimePeriods,
      ObjectSelectInput,
      ResponsiveTable,
      WorkOrderSummaryRow
    },
    computed: {
      invoicedToday () {
        if (this.dashboard.totalInvoicedToday) {
          return '$' + this.dashboard.totalInvoicedToday.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
        } else {
          return '$0.00'
        }
      },
      ...mapGetters([
        'liveFeed',
        'dashboard'
      ])
    },
    data () {
      return {
        myChart: '',
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        },
        reports: [],
        clientDashboard: [],
        timer: '',
        timePassed: 0,
        loadedTime: moment(),
        incomeData: {},
        reportTypeData: {},
        incomeChartScale: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            stacked: true
          }]
        }
      }
    },
    async mounted () {
      await this.$store.dispatch(LOAD_DASHBOARD)
      this.reports = this.dashboard.reports
      // console.log(this.dashboard.accountCodes)
      this.reportTypeData = this.dashboard.reportTypeData
      this.incomeData = this.dashboard.incomeData
      this.clientDashboard = this.dashboard.clientDashboard
      await this.$nextTick()
      if (this.$refs.reportTypeData && this.$refs.incomeData) {
        this.$refs.reportTypeData.refresh()
        this.$refs.incomeData.refresh()
        this.autoReloadTimer = setInterval(this.getNow, 60000)
      }
    },
    beforeDestroy () {
      clearInterval(this.autoReloadTimer)
    },
    methods: {
      getNow () {
        this.timePassed = moment().diff(this.loadedTime, 'minutes')
      },
      formatInvoiceAmount (invoiceAmount) {
        if (invoiceAmount) {
          return '$' + invoiceAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
        } else {
          return '$0.00'
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/Overview.vue